export default __webpack_public_path__ + "static/media/onboarding-background-down.8c132901.svg";